
import {Component, Mixins, Prop, Watch} from "vue-property-decorator";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import Dates from "@/components/inputs/Dates.vue";
import AvukatTalepTebligatTuruPicker from "@/components/pickers/uyap/AvukatTalepTebligatTuruPicker.vue";
import AvukatTalepAdresTuruPicker, {
  AvukatTalepAdresTuru
} from "@/components/pickers/uyap/AvukatTalepAdresTuruPicker.vue";
import {UyapHacizEvrakTuru} from "@/plugins/uyap-plugin/enum/uyap/evrak/UyapHacizEvrakTuru";
import {ADRES_KODU, tebligatAdresiDegeri, tebligatAdresiYok} from "@/utils/tebligatAdresi";

@Component({
  computed: {
    AvukatTalepAdresTuru: () => AvukatTalepAdresTuru
  },
  components: {
    AvukatTalepAdresTuruPicker,
    AvukatTalepTebligatTuruPicker,
    Dates
  }
})
export default class IhbarnameTalepEvrakEntryForm extends Mixins(ObjectInputMixin) {
  @Prop() dosyaId!: string;
  @Prop() tckn!: string;
  @Prop() vergiNo!: string;
  @Prop() borcluKisiKurumId!: number;
  @Prop() talepKodu!: number;

  localValue!: any;
  uyapHacizEvrakTuru = UyapHacizEvrakTuru;
  sorguProgress: boolean = false;

  get adresRule() {
    if (this.localValue.adresTuru == AvukatTalepAdresTuru.YENI) {
      if (!this.localValue.adres)
        return 'Lütfen bu alanı doldurun';
      if (this.localValue.adres.length > 1000)
        return 'Maksimum 1000 karakter kullanılabilir';
    }
    return true;
  }

  @Watch('localValue.adresTuru')
  onAdresTuruChange() {
    if (this.localValue.adresTuru == AvukatTalepAdresTuru.E_TEBLIGAT ||
        this.localValue.adresTuru == AvukatTalepAdresTuru.MERNIS ||
        this.localValue.adresTuru == AvukatTalepAdresTuru.MERSIS)
      this.adresSorgula();
  }

  /**
   * Yeni seçilen 3. şahısta adres türü varsayılan olarak E-Tebligat geliyor ama adres boş
   * kalıyordu; kullanıcı "Sorgula"ya basmazsa talep UYAP'a boş adresle gidip reddediliyordu
   * (DEV-3687). Adres boşsa form açılırken bir kez sorgulanır.
   */
  mounted() {
    if (!this.localValue.adres && this.localValue.kisiKurumId && this.adresSorguKodu)
      this.adresSorgula();
  }

  /** Adres türüne karşılık gelen UYAP sorgu kodu; sorgu gerekmiyorsa null. */
  get adresSorguKodu(): string | null {
    switch (this.localValue.adresTuru) {
      case AvukatTalepAdresTuru.E_TEBLIGAT:
        return ADRES_KODU.E_TEBLIGAT;
      case AvukatTalepAdresTuru.MERNIS:
        return ADRES_KODU.MERNIS;
      case AvukatTalepAdresTuru.MERSIS:
        return ADRES_KODU.MERSIS;
      default:
        // YENI elle yazılıyor; VEKILIN_E_TEBLIGAT için sorgu kodu bilinmiyor.
        return null;
    }
  }

  /**
   * Adres, borçlu için değil bu satırdaki ÜÇÜNCÜ ŞAHIS için sorgulanır; ihbarname ona
   * tebliğ ediliyor. Ayrıntı ve HAR referansları için bkz. utils/tebligatAdresi.ts
   */
  async adresSorgula() {
    this.sorguProgress = true;
    try {
      const kod = this.adresSorguKodu;
      if (kod) {
        this.localValue.adres = await this.tebligatAdresiCoz(kod);
        this.input();
      }
    } catch (e: any) {
      console.error("adresSorgula hatası:", e);
      this.$toast.error(e?.message || "Adres sorgulanamadı.");
    } finally {
      // Sorgu patlasa da spinner takılı kalmasın diye finally'de.
      setTimeout(() => {
        this.sorguProgress = false
      }, 2000)
    }
  }

  async tebligatAdresiCoz(adresKodu: string): Promise<string> {
    try {
      const cevap = await this.$uyap.GetIcraTebligatTalebiAdresSorgula().run({
        dosyaId: this.dosyaId,
        kisiKurumId: this.borcluKisiKurumId,
        kayitId: this.localValue.kisiKurumId,
        adresTuru: adresKodu
      });
      return tebligatAdresiDegeri(cevap, adresKodu);
    } catch (e: any) {
      // Kayıt yoksa UYAP errorCode'lu cevap veriyor; teknik hatalar yutulmaz.
      if (e?.errorCode) return tebligatAdresiYok(adresKodu);
      throw e;
    }
  }
}
